export default __webpack_public_path__ + "static/logo-a5d26f5ac0092d15325d88a0ec5d9123.png";